import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    
    private readonly defaultConfig = {
        timeOut: 5000,
        positionClass: 'toast-top-right'
    };

    private readonly successConfig = {
        timeOut: 3000,
        positionClass: 'toast-top-right'
    };

    constructor(private toastr: ToastrService) {}

    success(message: string, title: string = 'Sucesso'): void {
        this.toastr.success(message, title, this.successConfig);
    }

    warning(message: string, title: string = 'Atenção'): void {
        this.toastr.warning(message, title, this.defaultConfig);
    }

    error(message: string, title: string = 'Erro'): void {
        this.toastr.error(message, title, this.defaultConfig);
    }

    info(message: string, title: string = 'Informação'): void {
        this.toastr.info(message, title, this.defaultConfig);
    }
}
